import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SegundaViaCarneModalEnderecoComponent } from './segundaviacarne-modal-endereco.component';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { SegundaViaService } from '../services/segundavia.service';
import { EnderecoService } from '../services/endereco.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { SelectItem } from '../modelo/selectItem';
import { Estado } from '../enumaration/estado';
import { Contrato } from '../modelo/contrato';
import { Endereco } from '../modelo/endereco';
import { SegundaViaContrato } from '../modelo/segundaViaContrato';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-segundaviacarne-endereco',
  templateUrl: './segundaviacarne-endereco.component.html',
  styleUrls: ['./segundaviacarne.component.css'],
  providers: [SegundaViaService, EnderecoService, MensagemService, RestClientService]
})
export class SegundaViaCarneEnderecoComponent extends AbstractComponent implements OnInit {

  contrato: Contrato;
  endereco: Endereco = new Endereco();
  estadoList: SelectItem[];

  constructor(
    private sessaoService: SessaoService,
    private segundaViaService: SegundaViaService,
    private enderecoService: EnderecoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog) {
    super(sessaoService);

    // Cria combo de estado
    this.estadoList = Estado.values();
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);
    this.contrato = JSON.parse(sessionStorage.getItem('segundaViaContrato'));
    this.recuperarContrato(this.contrato);
    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Recupera as informações do contrato
   */
  recuperarContrato = (contrato: Contrato): void => {
    this.segundaViaService.recuperarContrato(contrato).subscribe(
      (result: Contrato) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno == "0") {
          this.contrato = result;
          this.buscaEndereco(this.contrato);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Realiza a busca de endereço
   */
  buscaEndereco = (contrato: Contrato): void => {
    this.enderecoService.recuperarEndereco(contrato).subscribe(
      (result: Contrato) => {
        if (result.cdMsgemRetorno == "0") {
          this.endereco = result.endereco
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * 
   * @param contrato 
   */
  onClickContrato(contrato: Contrato) {
    sessionStorage.setItem('contrato', JSON.stringify(contrato));
    sessionStorage.setItem('veioSegundaViaCarne', "S");
    this.router.navigate(['/BF-Portal/enderecoDados']);
  }

  /**
   * 
   * @param contrato 
   */
  modalConfirmar(contrato: Contrato): void {
    this.dialog.open(SegundaViaCarneModalEnderecoComponent, {
      width: Config.POPUP_100VW,
      data: {
        contrato: contrato
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundaviacarne-cli/segundaviacarne-endereco.component.ts